import {createSlice} from "@reduxjs/toolkit";
import {startOfMonth, subMonths} from "@ots-frontend/ots-data"
import {PipelineSettlementPageCriteria, setPipelineSettlementPageCriteria} from "./actions";

type PipelineSettlementPageState = {
  criteria: PipelineSettlementPageCriteria
}

const INITIAL_STATE: Readonly<PipelineSettlementPageState> = {
  criteria: {
    dttm: subMonths(startOfMonth(new Date()), 1).getTime(),
  }
};

const pipelineSettlementPageSlice = createSlice({
  name: "ui/pipeline-settlement-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setPipelineSettlementPageCriteria,
      (state, {payload}) => {
        state.criteria = payload
      }
    );
  }
});

export const pipelineSettlementPageReducer = pipelineSettlementPageSlice.reducer;
